
























































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
import { TranslateResult } from 'vue-i18n';


interface Obl {
    code: string; 
    obl: string; 
    region: string;
}

interface AteType {
    code: string; 
    name: string;
    $isDisabled?: boolean;
}

interface District {
    code: string; 
    name: string | TranslateResult;
}

interface RDistrict {
    code: string;   
    name: string | TranslateResult;
}

interface Snp {
    code: string; 
    name: string | TranslateResult;
}

interface Direction {
    code: string; 
    name: string | TranslateResult;
    $isDisabled?: boolean;
}

type CityCode = '71' | '75' | '79';
type LocaleCode = 'kk' | 'ru';


interface Year {
  id: number;
  year: number; 
}


@Component({
    components: {
        'multiselect': Multiselect
    }
})
export default class FormFilter extends Vue {
    @Prop({ default: '' }) source!: string;

    $refs!: {
        drop: any;
        snp: any;
        direction: any;
        year: any;
    };

    obl: Obl = {code: '', obl: '', region: ''};
    moduleCode = (
        this.source === 'srs-form' 
        ? '003.009.001' 
        : '003.009.003'
    ); 
    AteTypesList: AteType[] = []; 
    currAte: AteType = {code: '', name: ''};
    DistrictList: District[] = [];
    currDistrict: District | null = {code: '', name: ''}; 
    ruralDistrictList: RDistrict[] = [];
    currRuralDistrict: RDistrict | null = {code: '', name: ''};
    snpList: Snp[] = [];
    currSnp: Snp | null = {code: '', name: ''}; 
    directionList: Direction[] = [];
    currDirection: Direction | null = {code: '', name: ''};
    currYear: Year | null = null; 
    yearList: Year[] = [];
    isValid = true; // if all filter fields are valid
    filterValidationErrors = ['']; 
    rurDistMatch: RDistrict | null = {code: '', name: ''}; // доп требование для АТЕ=все и АТЕ=3
    snpMatch: Snp | null = {code: '', name: ''}; // доп требование для АТЕ=все и АТЕ=3

    get filterValidationMessages() {
        return {
            'district': this.$t('modules.srs.filter.filter_errors.district'),
            'rurDistrict': this.$t('modules.srs.filter.filter_errors.rural_district'),
            'snp': this.$t('modules.srs.filter.filter_errors.snp'),
            'direction': this.$t('modules.srs.filter.filter_errors.direction'),
            'year': this.$t('modules.srs.filter.filter_errors.year'),
        };
    }

    getNormalizedLocale(locale=this.$i18n.locale): string {
        return (locale === 'kk' || locale === 'kz') ? 'kz' : 'ru';
    }

    // отключение направлений "Культура и отдых", 
    // "Coциальное обеспечение" для АТЕ=5
    async isCultureAndLeasureDirectionDisabled() {
        const ateCode = this.currAte?.code;
        if (ateCode !== null) {
            return ateCode === '5'
        } else {
            const ateCodeForSnp = await this.getAteCodeForCurrentSnp() 
            return ateCodeForSnp === '5'
        }
    }

    // отключение направлений "Coциальное обеспечение" для АТЕ=4
    async isDirectionDisabled() {
        const ateCode = this.currAte?.code;
        if (ateCode !== null) {
            return ateCode === '4'
        } else {
            const ateCodeForSnp = await this.getAteCodeForCurrentSnp() 
            return ateCodeForSnp === '4'
        }
    }
    
    repCityList: Record<CityCode, Record<LocaleCode, string>> = {
        "71": {
            "kk": "АСТАНА ҚАЛАСЫ",
            "ru": "Г.АСТАНА",
        },
        "75": {
            "kk": "АЛМАТЫ ҚАЛАСЫ",
            "ru": "г.Алматы",
        },
        "79": {
            "kk": "ШЫМКЕНТ ҚАЛАСЫ",
            "ru": "г.Шымкент"
        }
    };

    async created() {
        await this.getObl(); 
        await this.get_ate_data(this.$i18n.locale);
        await this.get_district_data_by_ate(this.$i18n.locale);
        await this.get_rural_district_data_by_ate(this.$i18n.locale);
        await this.get_snp_data_by_ate(this.$i18n.locale);
        await this.get_direction_data(this.$i18n.locale);
        this.generateYearList(); 

        if (this.source === 'srs-form') {
            const FormFilterData = {
                ate: this.currAte,
                district: this.currDistrict,
                ruralDistrict: this.currRuralDistrict,
                snp: this.currSnp,
                direction: this?.currDirection,
                year: this?.currYear,
            };

            // parent will always catch it
            this.$nextTick(() => {
                this.$emit('default-filter', FormFilterData);
            });
        }
        
        if (this.source === 'srs-agree') {
            const AgreeFilterData = {
                ate: this.currAte,
                district: this.currDistrict,
                ruralDistrictList: this.ruralDistrictList,
                ruralDistrict: this.currRuralDistrict,
                snpList: this.snpList,
                snp: this.currSnp,
                directionList: this.directionList,
                direction: this.currDirection,
                year: this.currYear,
            };
            this.$nextTick(() => {
                this.$emit('default-filter', AgreeFilterData);
            });
        }
    }


    @Watch('$i18n.locale', { immediate: false })
    async onLocaleChange(newLocale: string, oldLocale: string) {
        if (!newLocale || newLocale.trim() === '' || !this.obl.code) {
            return;
        }

        // Clear validation errors
        this.filterValidationErrors = [''];
        this.isValid = true;
        this.currYear = this.yearList[this.yearList.length - 1] || null;

        await this.get_ate_data(newLocale);
        await this.get_district_data_by_ate(newLocale);
        await this.get_rural_district_data_by_ate(newLocale);
        await this.get_snp_data_by_ate(newLocale);
        await this.get_direction_data(newLocale);

        // force form re-render on locale change 
        // to fetch correct form data 
        if (this.source === 'srs-form') {
            const FormFilterData = {
                ate: this.currAte,
                district: this.currDistrict,
                ruralDistrict: this.currRuralDistrict,
                snp: this.currSnp,
                direction: this?.currDirection,
                year: this?.currYear,
            };

            // parent will always catch it
            this.$nextTick(() => {
                this.$emit('default-filter', FormFilterData);
            });
        }
    }

    // Watchers to clear errors when fields become non-empty
    @Watch('currDistrict')
    onDistrictChangeValidation(newValue: District | null) {
        if (newValue !== null && newValue.code !== '') {
            this.clearFieldError('district');
        }
        this.onDistrictChange(newValue);
    }

    @Watch('currRuralDistrict')
    onRuralDistrictChangeValidation(newValue: RDistrict | null) {
        if (newValue !== null && newValue.code !== '') {
            this.clearFieldError('rurDistrict');
        }
        this.onRuralDistrictChange(newValue);
    }

    @Watch('currSnp')
    onSnpChangeValidation(newValue: Snp | null) {
        if (newValue !== null && newValue.code !== '') {
            this.clearFieldError('snp');
        }
        this.get_direction_data(this.$i18n.locale);
    }

    @Watch('currDirection')
    onDirectionChangeValidation(newValue: Direction | null) {
        if (newValue !== null && newValue.code !== '') {
            this.clearFieldError('direction');
        }
    }

    @Watch('currYear')
    onYearChangeValidation(newValue: Year | null) {
        if (newValue !== null) {
            this.clearFieldError('year');
        }
    }

    async onAteChange() {
        await this.get_district_data_by_ate(this.$i18n.locale);
        await this.get_rural_district_data_by_ate(this.$i18n.locale);
        await this.get_snp_data_by_ate(this.$i18n.locale);
        await this.get_direction_data(this.$i18n.locale);
        this.currYear = this.yearList[this.yearList.length - 1] || null;
    }

    async onDistrictChange(selectedDistrict: District | null) {
        await this.get_rural_district_data_by_ate(this.$i18n.locale);
        await this.get_snp_data_by_ate(this.$i18n.locale);
    }

    async onRuralDistrictChange(selectedRuralDistrict: RDistrict | null) { 
        await this.get_snp_data_by_ate(this.$i18n.locale);
    }

    onClickApply() {
        // clear prev filter validation errors 
        this.filterValidationErrors = [''];
        this.isValid = true;
        this.validateFilterFields();
        if (!this.isValid) {
            return; 
        }

        if (this.source === 'srs-form') {
            const FormFilterData = {
                ate: this.currAte,
                district: this.currDistrict,
                ruralDistrict: this.currRuralDistrict,
                snp: this.currSnp,
                direction: this.currDirection,
                year: this.currYear,
            };

            this.$emit('apply-filter', FormFilterData);
        }

        if (this.source === 'srs-agree') {
            const AgreeFilterData = {
                ate: this.currAte,
                district: this.currDistrict,
                ruralDistrictList: this.ruralDistrictList,
                ruralDistrict: this.currRuralDistrict,
                snpList: this.snpList,
                snp: this.currSnp,
                directionList: this.directionList,
                direction: this.currDirection,
                year: this.currYear,
            };

            this.$emit('apply-filter', AgreeFilterData);
        }

        // hide on apply
        this.$refs.drop.hide(true);
    }

    async onClickReset() {
        await this.get_ate_data(this.$i18n.locale);
        await this.get_district_data_by_ate(this.$i18n.locale);
        await this.get_rural_district_data_by_ate(this.$i18n.locale);
        await this.get_snp_data_by_ate(this.$i18n.locale);
        await this.get_direction_data(this.$i18n.locale);
        this.currYear = this.yearList[this.yearList.length - 1] || null;
        this.isValid = true;

        if (this.source === 'srs-form') {
            const FormFilterData = {
                ate: this.currAte,
                district: this.currDistrict,
                ruralDistrict: this.currRuralDistrict,
                snp: this.currSnp,
                direction: this.currDirection,
                year: this.currYear,
            };

            this.$emit('reset-filter', FormFilterData);
        }
        
        if (this.source === 'srs-agree') {
            const AgreeFilterData = {
                ate: this.currAte,
                district: this.currDistrict,
                ruralDistrictList: this.ruralDistrictList,
                ruralDistrict: this.currRuralDistrict,
                snpList: this.snpList,
                snp: this.currSnp,
                directionList: this.directionList,
                direction: this.currDirection,
                year: this.currYear,
            };

            this.$emit('reset-filter', AgreeFilterData);
        }
    }

    async getObl(): Promise<void> {
        try {
            const response = await fetch(`/api-py/get-budget-obl/${this.$store.state._instanceCode}`)
            this.obl = await response.json();
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                String(this.$t('modules.srs.warnings.get_obl_error')), 
                err.message || err.toString()
            );
        }
    }

    async get_ate_data(locale: string): Promise<void> {
        try {
            const userData = { 
              userId: this.$store.getters.user_uuid,
              moduleCode: this.moduleCode 
            };

            const response = await fetch(`/api-py/srs/ate/${this.obl.code}?lang=${locale}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            }); 

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            // user в Системе с области
            this.AteTypesList = await response.json();
            // деактивировать code = '1' Город республиканского значения
            const itemWithCodeOne = this.AteTypesList.find(item => item.code === '1');
            if (itemWithCodeOne) {
                itemWithCodeOne.$isDisabled = true;
            }
            // user в Системе с Города республиканского значения
            if (this.isCityOfRepubSignificance(this.obl.code)) {
                this.AteTypesList = this.AteTypesList.filter(item => item.code == '1')
                this.setSnpField(); 
            } 
            this.currAte = this.AteTypesList[0];
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                String(this.$t('modules.srs.warnings.ate_error')), 
                err.message || err.toString()
            );
        } 
    }

    async get_district_data_by_ate(locale: string): Promise<void> {
        try {
            const userData = { 
              userId: this.$store.getters.user_uuid,
              moduleCode: this.moduleCode 
            };

            const ateCode = this.currAte.code !== null ? this.currAte.code : '0';
            const response = await fetch(`/api-py/srs/district/${this.obl.code}?ate=${ateCode}&lang=${locale}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            }); 

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            this.DistrictList = await response.json();
            this.currDistrict = this.DistrictList[0]; 
    
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                String(this.$t('modules.srs.warnings.district_error')),
                err.message || err.toString()
            );
        }
    }

    async get_rural_district_data_by_ate(locale: string): Promise<void> {
        try {
            // Поле Район/город не выбрано
            if (this.currDistrict === null) {
                this.ruralDistrictList = [];
                this.currRuralDistrict = null;
                return; 
            }

            const userData = { 
              userId: this.$store.getters.user_uuid,
              moduleCode: this.moduleCode 
            };

            const optionAll = { 
                code: '', 
                name: this.$t('modules.srs.filter.filter_options.all')
            };

            const ateCode = this.currAte.code !== null ? this.currAte.code : '0';
            const dist = this.currDistrict.code;
            const response = await fetch(`/api-py/srs/rural/${this.obl.code}?ate=${ateCode}${dist !== '' ? `&dist=${dist}` : ''}&lang=${locale}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            }); 

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
        
            this.ruralDistrictList = await response.json();

            // Пустой список
            if (this.ruralDistrictList.length === 0) {
                this.currRuralDistrict = null;
                return;
            }

            this.source === 'srs-agree' && this.ruralDistrictList.unshift(optionAll);
            // доп требование для АТЕ=3, предзаполняем (1)-(4.1)-(7.1)
            if ((this.isQ1Sample(dist)) && (ateCode === '3')) {
                this.rurDistMatch = this.findByCodeMatch(this.ruralDistrictList, '30', 4, 6); 
                this.currRuralDistrict = (
                    this.rurDistMatch ? this.rurDistMatch 
                    : this.ruralDistrictList.length > 0 
                    ? this.source === 'srs-agree' 
                        ? this.ruralDistrictList[1] 
                        : this.ruralDistrictList[0]
                    : null
                );
            } else {
                this.currRuralDistrict = (
                    this.ruralDistrictList.length > 0 
                    ? this.source === 'srs-agree' 
                        ? this.ruralDistrictList[1] 
                        : this.ruralDistrictList[0] 
                    : null
                ); 
            }

        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                String(this.$t('modules.srs.warnings.rurdist_error')), 
                err.message || err.toString()
            );
        }
    }


    async get_snp_data_by_ate(locale: string): Promise<void> {
        try {
            // Поле Район/город или Сельский округ не выбраны/пустые
            if (this.DistrictList.length === 0 || this.ruralDistrictList.length === 0) {
                this.snpList = [];
                this.currSnp = null;
                return; 
            }
            // В списке только "Все"
            if (this.source === 'srs-agree') {
                if (this.ruralDistrictList.length === 1 && this.ruralDistrictList[0].code === '') {
                    this.snpList = [];
                    this.currSnp = null;
                    return;
                }
            }

            const userData = { 
              userId: this.$store.getters.user_uuid,
              moduleCode: this.moduleCode 
            };

            const optionAll = { 
                code: '', 
                name: this.$t('modules.srs.filter.filter_options.all')
            };

            const ateCode = this.currAte.code !== null ? this.currAte.code : '0';
            const dist = this.currDistrict?.code;
            const rurDist = this.currRuralDistrict?.code;

            // В поле с.о. "Все" -> в поле HП/СНП "Все"
            if (rurDist === '' && this.currRuralDistrict?.name == optionAll.name) {
                this.currSnp = optionAll;
                this.snpList = [this.currSnp];
                return; 
            }
            const response = await fetch(`/api-py/srs/snp/${this.obl.code}?ate=${ateCode}${dist !== '' ? `&dist=${dist}` : ''}${rurDist !== '' ? `&rurDist=${rurDist}` : ''}&lang=${locale}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            }); 

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            this.snpList = await response.json(); 
            this.source === 'srs-agree' && this.snpList.unshift(optionAll);
            // доп требование для АТЕ=3, предзаполняем (1)-(4.1)-(7.1)
            if ((ateCode === '3') && (this.rurDistMatch !== null)) {
                this.snpMatch = this.findByCodeMatch(this.snpList, '100', 6, 9);
                this.currSnp = (
                    this.snpMatch ? this.snpMatch 
                    : this.snpList.length > 0 
                    ? this.source === 'srs-agree' 
                        ? this.snpList[1] 
                        : this.snpList[0]
                    : null
                );
            } else {
                this.currSnp = (
                    this.snpList.length > 0 
                    ? this.source === 'srs-agree' 
                        ? this.snpList[1] 
                        : this.snpList[0] 
                    : null
                ); 
            }
            
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                String(this.$t('modules.srs.warnings.snp_error')),
                err.message || err.toString()
            );
        }
    }

    
    async get_direction_data(locale: string): Promise<void> {
        try {
            const response = await fetch(`/api-py/srs/direction?lang=${locale}`);
            this.directionList = await response.json();
            // disable '03' and '05'
            const isCultureLeasureDisabled = await this.isCultureAndLeasureDirectionDisabled();
            const isDirectionDisabled = await this.isDirectionDisabled();
            const disabledDirectionCodes = ['03', '05'];
            if (isCultureLeasureDisabled) {
                this.directionList.forEach(item => {
                    if (disabledDirectionCodes.includes(item.code)) {
                        item.$isDisabled = true;
                    }
                });
            } else if (isDirectionDisabled) {
                const item = this.directionList.find(item => item.code === '03');
                if (item) {
                    item.$isDisabled = true;
                }
            }
            
            const optionAll = { 
                code: '', 
                name: this.$t('modules.srs.filter.filter_options.all')
            };

            if (
                this.source === 'srs-agree' &&
                this.directionList.length > 0 &&
                this.directionList[0].code !== optionAll.code
            ) { this.directionList.unshift(optionAll) }; 

            this.currDirection = (
                this.source === 'srs-agree' 
                ? this.directionList[1] 
                : this.directionList[0]
            );
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger', 
                String(this.$t('modules.srs.warnings.direction_error')), 
                err.message || err.toString()
            );
        }
    }

    // предварительная логика для поля СНП/HП 
    // пользователь в Системе с Города республиканского значения
    setSnpField() {
        const code = `${this.obl.code}0000000`
        const city = this.repCityList[this.obl.code as CityCode][this.$i18n.locale as LocaleCode];
        this.$refs.snp.setValue({
            code: code,
            name: city
        });
    }

    isCityOfRepubSignificance(kato: string): boolean {
        return kato > '70';                    
    }

    generateYearList(): Year[] {
        const startYear = 2024;
        const currentYear = new Date().getFullYear()-1;

        for (let year = startYear; year <= currentYear; year++) {
            const index = year - startYear + 1;
            const obj: Year = { 
                id: index, 
                year: year 
            };
            this.yearList.push(obj);
        }
        this.currYear = this.yearList[this.yearList.length - 1] || null;
        return this.yearList;
    }

    validateFilterFields(): boolean {
        if (this.currDistrict === null) {
            this.filterValidationErrors.push('district');
            this.isValid = false;
        }
        if (this.currRuralDistrict === null) {
            this.filterValidationErrors.push('rurDistrict');
            this.isValid = false;
        }
        if (this.currSnp === null || this.currSnp === undefined) {
            this.filterValidationErrors.push('snp');
            this.isValid = false;
        }
        if (this.currDirection === null) {
            this.filterValidationErrors.push('direction');
            this.isValid = false;
        }
        if (this.currYear === null) {
            this.filterValidationErrors.push('year');
            this.isValid = false;
        }
        return this.isValid;
    }

    getFieldError(field: string) {
        if (field === 'district') {
            return this.filterValidationMessages['district'];
        }

        if (field === 'rurDistrict') {
            return this.filterValidationMessages['rurDistrict'];
        }

        if (field === 'snp') {
            return this.filterValidationMessages['snp'];
        }

        if (field === 'direction') {
            return this.filterValidationMessages['direction'];
        }

        if (field === 'year') {
            return this.filterValidationMessages['year'];
        }   
    }

    clearFieldError(fieldName: string) {
        const index = this.filterValidationErrors.indexOf(fieldName);
        if (index > -1) {
            this.filterValidationErrors.splice(index, 1);
        }
        
        // If no more errors, set isValid to true
        if (this.filterValidationErrors.length <= 1) { // <= 1 because we initialize with ['']
            this.isValid = true;
            this.filterValidationErrors = [''];
        }
    }

    findByCodeMatch(arr: RDistrict[] | Snp[], match: String, l: number, r: number) {
        return arr.find(obj => obj.code.slice(l, r) === match) || null;
    }

    isQ1Sample(code: String): boolean {
        return (code.slice(2, 4) >= '30' && code.slice(4, 6) === '00' && code.slice(6, 9) === '000');
    }

    async getAteCodeForCurrentSnp(): Promise<string | undefined> {
        try {
            const ateCode = this.currAte?.code; 
            if (ateCode !== null) return; 

            const distCode = this.currDistrict?.code;
            const rurCode = this.currRuralDistrict?.code;
            const snpCode = this.currSnp?.code;
            const locale = this.getNormalizedLocale();

            const response = await fetch(`/api-py/srs/form/ate/${this.obl.code}?distCode=${distCode}&rurCode=${rurCode}&snpCode=${snpCode}&lang=${locale}`); 

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const ateCodeForSnp = await response.json();
            return ateCodeForSnp;

        } catch (error) {
            const err = error as Error;
            this.makeToast(
            'danger', 
            'Error fetching getAteCodeForCurrentSnp()', 
            err.message || err.toString()
            );
        }
    }


    openFilterByRef(refName: string) {
        const drop = this.$refs.drop;
        drop.show(true);
        this.$emit('openFilterByRef', refName);
        let refItem: any;
        switch (refName) {
            case 'snp':
                refItem = this.$refs.snp;
                break;
            case 'filterDate':
                refItem = this.$refs.direction;
                break;
            default:
                break;
        }
        setTimeout(() => refItem.$el.focus(), 100);
    }

    makeToast(variant: string, toastBody: string, title: string): void {
        (this as any).$bvToast.toast(toastBody, {
            title: title,
            variant: variant,
            autoHideDelay: 2000,
            solid: true
        });
    }
}
